<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="close_button" @click="$emit('close')">
        <!-- <img src="../assets/img/keyword/close.svg"> -->
        <div class="close_button_inner"></div>
      </div>
      <div class="modal-window">
        <div class="modal-content">
          <slot/>
          <!-- <div class="modal-prev" @click="$emit('prev')" v-show="prevButton"><img src="../assets/equipment/prev_line.svg"></div> -->
          <!-- <div class="modal-next" @click="$emit('next')" v-show="nextButton"><img src="../assets/equipment/next_line.svg"></div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MyModal',
  props: {
    // prevButton: Boolean,
    // nextButton: Boolean
	},
}
</script>

<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    background: #fff;
    overflow: hidden;
    max-width: 1000px;
    width: 90%;
    overflow-y: scroll;
  }

  &-content {
    width: 100%;
    margin: 0 auto;
    position: relative;
    // padding: 10px 20px;
    img {
      width: 100%;
    }
  }
}
// .modal-prev {
//   left: 5px;
//   width: 30px;
//   display: inline-block;
//   position: absolute;
//   top: 50%;
//   transform: translateY(-50%);
//   z-index: 100;
//   cursor: pointer;
//   img {
//     position: relative;
//     z-index: -1;
//     cursor: pointer;
//   }
// }
// .modal-next {
//   right: 5px;
//   width: 30px;
//   display: inline-block;
//   position: absolute;
//   top: 50%;
//   transform: translateY(-50%);
//   z-index: 100;
//   cursor: pointer;
//   img {
//     position: relative;
//     z-index: -1;
//     cursor: pointer;
//   }
// }
.section-reserve .modal,.section-plan .modal,.main-footer .modal {
  &.modal-overlay {
    flex-direction: column;
  }
  &-window {
    margin-top: 30px;
    margin-bottom: 30px;
    max-width: 96%;
    width: 600px;
    overflow: scroll;
  }
}
// オーバーレイのトランジション
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
.close_button {
  position: relative;
  text-align: right;
  top: 0;
  width: 90%;
  max-width: 1000px;
  margin: 0 auto;
  cursor: pointer;
  height: 50px;
  .close_button_inner {
    width: 30px;
    height: 30px;
    background-size: 100%;
    position: absolute;
    right: 0;
  }
}
</style>
